var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBat2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 96,
    viewBox: "0 0 140 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6977 68.2609C54.2341 67.966 53.034 67.4704 53.312 66.3476C53.4454 65.8063 54.0668 64.962 53.7143 64.8262C53.1699 64.6173 51.8208 65.9567 51.1814 66.5809C47.572 70.1054 43.8665 67.6353 42.3619 65.4208C37.1323 57.7267 40.2372 41.6412 33.8992 30.96C27.7172 20.5407 13.3577 2.80268 0.376465 0.472061C5.13332 5.79935 8.04129 8.34776 4.82729 16.3394C16.1651 18.5471 15.6634 31.086 11.2596 39.1184C20.7729 44.9855 29.1997 50.1601 23.4221 61.538C32.8957 60.443 43.3454 78.5809 43.8031 85.3659C45.4211 82.8268 54.6977 68.2609 54.6977 68.2609Z",
    fill: "url(#paint0_linear_501_2412)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6969 68.2609C55.1604 68.5567 56.1151 69.4355 57.0203 68.7076C57.4547 68.3582 57.9576 67.4384 58.2292 67.6983C58.649 68.1041 58.0033 69.8924 57.708 70.735C56.0335 75.4944 59.8381 77.8117 62.4818 78.2412C71.6635 79.7354 84.9359 70.1326 97.2951 71.3707C109.35 72.579 131.491 78.1113 139.082 88.896C132.245 86.8321 128.708 85.2708 122.819 91.5577C116.032 82.2107 104.878 87.9542 99.4552 95.3386C90.1213 89.1896 81.874 83.733 73.9999 93.7731C70.9934 84.7224 50.1416 82.9034 43.7966 85.3503C45.4091 82.8168 54.6969 68.2609 54.6969 68.2609Z",
    fill: "url(#paint1_linear_501_2412)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_501_2412",
    x1: -2.77746,
    y1: 40.983,
    x2: 56.4623,
    y2: 45.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20283B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#1E2537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#191F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#121419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F1012"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_501_2412",
    x1: 44.2896,
    y1: 79.0177,
    x2: 139.275,
    y2: 86.4127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20283B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#1E2537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#191F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#121419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F1012"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBat2);
export default __webpack_public_path__ + "static/media/bat2.7041b319f9679ff8294777de5924c9c1.svg";
export { ForwardRef as ReactComponent };